import { render, staticRenderFns } from "./customer-transactions.vue?vue&type=template&id=0400502f"
import script from "./customer-transactions.vue?vue&type=script&lang=js"
export * from "./customer-transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports